import { useState, useRef, useEffect } from 'react';
import { AvatarSceneProps, animationModes } from '../../../components/AvatarScene';
import { useControlledTimeout } from '../../useControlledTimeout/useControlledTimeout';
import { useControlledInterval } from '../../useControlledInterval/useControlledInterval';

export const useStatesAndTimers = () => {
    const [animationMode, setAnimationMode] = useState<AvatarSceneProps['mode']>(animationModes.IDLE);
    const [cardText, setCardText] = useState<string | undefined>();
    const [prepTime, setPrepTime] = useState(0);
    const [monologueTime, setMonologueTime] = useState(0);
    const [isAnimationLoading, setIsAnimationLoading] = useState(true);
    const [promptTimer, setPromptTimer] = useState(0);
    const [partTimer, setPartTimer] = useState(0);
    const [currentSubTitle, setCurrentSubTitle] = useState('');
    const [uploadingTest, setUploadingTest] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const [enableHoeltPart2, setEnableHoeltPart2] = useState<boolean>(false);

    const speakingTimeout = useControlledTimeout();
    const noResponseTimeout = useControlledTimeout();
    const encourageTimeout = useControlledTimeout();
    const partInterval = useControlledInterval();
    const promptInterval = useControlledInterval();
    const prepTimeInterval = useControlledInterval();
    const skipCurrentPartRef = useRef(false); // flag to skip current part when part timer reaches a certain point
    const subTitleRef = useRef<any>([]);
    const isVariantPlayedRef = useRef(false);
    const skipCurrentFrameRef = useRef(false);
    const firstMessageDurationRef = useRef(3);
    const currentFrameRef = useRef('');
    const isFirstAudioPlayedRef = useRef(false);
    const timerPausedRef = useRef(false);

    const pause = () => {
        setAnimationMode('IDLE')
        speakingTimeout.pause();
        noResponseTimeout.pause();
        encourageTimeout.pause();
        promptInterval.pause();
        partInterval.pause();
        prepTimeInterval.pause()
    };

    const resume = () => {
        speakingTimeout.resume();
        noResponseTimeout.resume();
        encourageTimeout.resume();
        promptInterval.resume();
        partInterval.resume();
        prepTimeInterval.resume()
    };

    useEffect(() => {
        return () => {
            speakingTimeout.clear();
            noResponseTimeout.clear();
            encourageTimeout.clear();
            promptInterval.clear();
            partInterval.clear();
            prepTimeInterval.clear();
            skipCurrentPartRef.current = false;
        };
    }, []);

    return {
        states: {
            animationMode,
            setAnimationMode,
            cardText,
            setCardText,
            prepTime,
            setPrepTime,
            monologueTime,
            setMonologueTime,
            isAnimationLoading,
            setIsAnimationLoading,
            promptTimer,
            setPromptTimer,
            partTimer,
            setPartTimer,
            currentSubTitle,
            setCurrentSubTitle,
            uploadingTest,
            setUploadingTest,
            error,
            setError,
            enableHoeltPart2,
            setEnableHoeltPart2,
        },
        timeouts: {
            speakingTimeout,
            noResponseTimeout,
            encourageTimeout,
        },
        intervals: {
            promptInterval,
            partInterval,
            prepTimeInterval,
        },
        refs: {
            skipCurrentPartRef,
            subTitleRef,
            isVariantPlayedRef,
            skipCurrentFrameRef,
            firstMessageDurationRef,
            currentFrameRef,
            timerPausedRef,
            isFirstAudioPlayedRef
        },
        fns: {
            pause,
            resume,
        },
        data: {
            interrupTimer: Math.min(promptTimer, partTimer),
        },
    };
};
